export default "__VITE_ASSET__bc5b5d90__"